export default {
  attendant: 'Atendente',
  status: 'Online',
  paused: 'Em pausa',
  invisible: 'Invisível',
  total: 'Total',
};
